<form [formGroup]="form" class="signup__form" (submit)="submitForm()" novalidate>
    <ng-container *ngIf="userType === UserType.candidate">
        <sp-form-input
            [control]="controls['firstName']"
            class="signup-form__{{ controls['firstName'].name }}"
        ></sp-form-input>
        <sp-form-input
            [control]="controls['lastName']"
            class="signup-form__{{ controls['lastName'].name }}"
        ></sp-form-input>
        <sp-form-input
            [control]="controls['email']"
            class="signup-form__{{ controls['email'].name }}"
        ></sp-form-input>
        <sp-form-input
            [control]="controls['password']"
            class="signup-form__{{ controls['password'].name }}"
        ></sp-form-input>
    </ng-container>

    <ng-container *ngIf="userType === UserType.employer">
        <label class="form-error-message message-top" *ngIf="error && isInvitationError">
            <span *ngIf="error === SignupErrorType.invitationExpiredError">
                The registration link you followed has expired. Please ask the account owner to send
                you a new one.
            </span>

            <span *ngIf="error === SignupErrorType.invitationUsedError">
                The registration link you followed has already been used. Please login with your
                credentials.
            </span>

            <span *ngIf="error === SignupErrorType.invitationNotFoundError">
                The provided link is invalid.
            </span>
        </label>

        <sp-form-input
            [control]="controls['email']"
            class="signup-form__{{ controls['email'].name }}"
        ></sp-form-input>
        <sp-form-input
            [control]="controls['firstName']"
            class="signup-form__{{ controls['firstName'].name }}"
        ></sp-form-input>
        <sp-form-input
            [control]="controls['lastName']"
            class="signup-form__{{ controls['lastName'].name }}"
        ></sp-form-input>

        <!-- employer data provided via third-party service, e.g. Clearbit -->

        <ng-container *ngIf="showFullEmployerSignupForm">
            <sp-form-input
                [control]="controls['position']"
                class="signup-form__{{ controls['position'].name }}"
            >
            </sp-form-input>
            <sp-form-input
                [control]="controls['password']"
                class="signup-form__{{ controls['password'].name }}"
            >
            </sp-form-input>
            <sp-form-input
                [control]="controls['phoneNumber']"
                class="signup-form__{{ controls['phoneNumber'].name }}"
            ></sp-form-input>
            <sp-form-input
                [control]="controls['registrationCode']"
                class="signup-form__{{ controls['registrationCode'].name }}"
            ></sp-form-input>
        </ng-container>

        <div *ngIf="isSubmitting" class="spinner-wrapper">
            <img src="/images/spinner.svg" class="sp-dots-spinner spinner" />
        </div>
    </ng-container>

    <label class="form-error-message" *ngIf="error && !isInvitationError">
        <span *ngIf="error === SignupErrorType.genericError">
            There was an error while trying to sign you up.<br />
            Please try again later.
        </span>

        <span *ngIf="error === SignupErrorType.forbiddenEmailDomainError">
            If you are an employer, please register with your work email. If you are a candidate,
            please
            <a href="javascript:" [routerLink]="['/signup', 'candidate']" class="error-message-link"
                >sign up here</a
            >.
        </span>

        <span *ngIf="error === SignupErrorType.incorrectVerificationLink">
            The verification link you’ve accessed is either invalid or expired. Please enter your
            email address to request a new one.
        </span>

        <span *ngIf="error === SignupErrorType.emailAlreadyUsedError">
            There is already an account associated with this email address.
            <a href="javascript:" (click)="redirectToSignIn()" class="error-message-link"
                >Click here</a
            >
            to sign in.
        </span>

        <span *ngIf="error === SignupErrorType.invalidEmployerRegistrationCodeError">
            The registration code provided is invalid. Please enter another or contact support at
            info@squarepeghires.com.
        </span>
    </label>

    <button
        class="submit-btn"
        type="submit"
        name="submit"
        [disabled]="form.invalid || form.pristine || isSubmitting"
    >
        {{ ctaButtonLabel }}
        <span *ngIf="showNextLabel" class="forward-icon"></span>
    </button>
</form>
